import Oidc from 'oidc-client';

const mgr = new Oidc.UserManager({
    authority: process.env.VUE_APP_API_ACESSO_RAIZ,
    client_id: process.env.VUE_APP_API_CLIENT_ID,
    redirect_uri: process.env.VUE_APP_API_IDENTITY_SERVER_CALLBACK,
    response_type: 'id_token token',
    scope: 'openid profile api-acesso-admin api-pbs',
    post_logout_redirect_uri: process.env.VUE_APP_POST_LOGOUT_REDIRECT_URI,
    userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: true,
    silent_redirect_uri: process.env.VUE_APP_SILENT_REDIRECT_URI,
    filterProtocolClaims: true,
    accessTokenExpiringNotificationTime: 50
})

export default mgr;



